let widgetCaptcha = false;
export const getGoogleCaptchaToken = async (action = 'submit') => {
  if (typeof window === 'undefined') return Promise.resolve('');
  const ready = function(cb) {
    if (typeof grecaptcha === 'undefined') {
      const c = '___grecaptcha_cfg';
      window[c] = window[c] || {};
      (window[c].fns = window[c].fns || []).push(cb);
    } else {
      cb();
    }
  };

  const gr = typeof grecaptcha === 'undefined' ? { ready } : grecaptcha;
  return new Promise((resolve, reject) => {
    gr.ready(() => {
      gr
        .execute('6LdWm20eAAAAAOdt2VXiYuupWU9DNobcIUVES4wK', { action })
        .then(resolve)
        .catch(reject);
    });
  });
};

export const getGoogleCaptchaTokenV2 = async (id = 'captcha', onReady = () => {}, cb = () => {}) => {
  if (typeof window === 'undefined' || !document.getElementById(id)) return Promise.resolve('');
  const ready = function(cb) {
    if (typeof grecaptcha === 'undefined') {
      const c = '___grecaptcha_cfg';
      window[c] = window[c] || {};
      (window[c].fns = window[c].fns || []).push(cb);
    } else {
      cb();
    }
  };

  const gr = typeof grecaptcha === 'undefined' ? { ready } : grecaptcha;
  return new Promise((resolve, reject) => {
    gr.ready(() => {
      try {
        if (widgetCaptcha !== false) {
          gr.reset(widgetCaptcha);
          return;
        }
        widgetCaptcha = gr.render(id, {
          sitekey: '6LfbjpceAAAAAKewRjU4XYRjUDIzqeSKnr0v-HWf',
          // theme: 'dark',
          callback: token => {
            console.info('token V2', token);
            resolve(token);
            cb(token);
          },
          'expired-callback': error => {
            console.info('expired-callback', error);
            reject();
            cb();
          },
          'error-callback': error => {
            console.info('error-callback', error);
            reject();
            cb();
          },
        });
        console.log('widgetCaptcha', widgetCaptcha);
      } catch (error) {
        console.log(error);
        reject(error);
      }
      onReady(gr);
    });
  });
};



// WEBPACK FOOTER //
// ./src/shared/helpers/google.js